import { render, staticRenderFns } from "./LogisticsTemplateManageDetail.vue?vue&type=template&id=01cbc1f5&scoped=true"
import script from "./LogisticsTemplateManageDetail.vue?vue&type=script&lang=js"
export * from "./LogisticsTemplateManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cbc1f5",
  null
  
)

export default component.exports